import { render, staticRenderFns } from "./PublicQuotationPages10.vue?vue&type=template&id=7881b65f&scoped=true&"
import script from "./PublicQuotationPages10.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881b65f",
  null
  
)

export default component.exports